// eslint-disable-next-line no-restricted-imports
import {
  default as Button,
  type ButtonProps as AntButtonProps
} from 'antd/es/button';
import type { ForwardedRef } from 'react';
import { forwardRef } from 'react';

export const NewButton = forwardRef<HTMLButtonElement, AntButtonProps>(
  ({ ...props }, ref: ForwardedRef<HTMLButtonElement>) => {
    return (
      <div className="fancy-brand-border-gradient rounded-full p-[2px]">
        <Button
          className="fancy-brand-gradient relative flex h-[43px] cursor-pointer flex-row items-center justify-center gap-2 whitespace-nowrap rounded-full border-none px-6 py-4 hover:brightness-105 [&:active]:brightness-110"
          type="primary"
          ref={ref}
          {...props}
        />
      </div>
    );
  }
);

NewButton.displayName = 'NewButton';
